﻿/**
 * Dolce Vita Halı - Menü Düzeltmeleri v2
 * FIX: _onSummaryClicked override — click-opened tracking
 * FIX (empty-cart mobile): hdt-header-menu custom element henüz register
 *      olmadan .toggle() çağrılıyordu → TypeError: menu.toggle is not a function.
 *      Çözüm: customElements.whenDefined('hdt-header-menu') ile bekle +
 *      her .toggle() çağrısında typeof guard (race/AJAX rerender için).
 */
(function() {
  var scheduleInit = window.requestIdleCallback || window.setTimeout;
  var isTouchDevice = ('ontouchstart' in window) || (navigator.maxTouchPoints > 0);

  document.body.classList.add(isTouchDevice ? 'touch-device' : 'no-touch-device');
  if (window.location.pathname.includes('/collections/')) {
    document.body.classList.add('is-collection-page');
  }

  function safeToggle(menu, value) {
    // hdt-header-menu custom element henüz upgrade olmamışsa toggle yok.
    // Bu durumda native <details> .open attribute fallback'i ile sessizce geç;
    // upgrade sonrası normal akış devreye girecek.
    if (menu && typeof menu.toggle === 'function') {
      menu.toggle(value);
      return true;
    }
    return false;
  }

  function startWhenReady() {
    // hdt-header-menu customized built-in element; global.min.js yüklendiğinde
    // register olur. Tanımlanana kadar bekle, sonra init et.
    if (window.customElements && typeof window.customElements.whenDefined === 'function') {
      window.customElements.whenDefined('hdt-header-menu').then(function() {
        scheduleInit(init, { timeout: 300 });
      }).catch(function() {
        scheduleInit(init, { timeout: 300 });
      });
      // whenDefined hiç resolve olmazsa (custom element yok) gene de init'i çağır
      // ki menuItems boşsa kendini iptal etsin. Küçük bir güvenlik süresi:
      setTimeout(function() { scheduleInit(init, { timeout: 300 }); }, 3000);
    } else {
      scheduleInit(init, { timeout: 300 });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startWhenReady);
  } else {
    startWhenReady();
  }

  var _initDone = false;
  function init() {
    if (_initDone) return;
    var menuItems = document.querySelectorAll('#hdt-nav-ul > li.hdt-has-children > details[is="hdt-header-menu"]');
    if (!menuItems.length) return;
    _initDone = true;

    menuItems.forEach(function(menu) {
      // Desktop: hover ile aç/kapat (MegaMenu API kullan, doğrudan attr set etme)
      if (!isTouchDevice) {
        menu.addEventListener('mouseenter', function() {
          if (safeToggle(menu, true) && menu.summaryElement) {
            menu.summaryElement.classList.add('is_action-hover');
          }
        });

        menu.addEventListener('mouseleave', function() {
          if (!menu.hasAttribute('click-opened')) {
            if (safeToggle(menu, false) && menu.summaryElement) {
              menu.summaryElement.classList.remove('is_action-hover');
            }
          }
        });
      }

      // _onSummaryClicked override — ilk tıklama aç, ikinci tıklama navigate
      menu._onSummaryClicked = function(t) {
        var url = this.summaryElement && this.summaryElement.getAttribute('data-url');

        if (this.hasAttribute('click-opened')) {
          this.removeAttribute('click-opened');
          if (url && url !== '#') {
            window.location.href = url;
            return;
          }
          if (safeToggle(this, false) && this.summaryElement) {
            this.summaryElement.classList.remove('is_action-hover');
          }
          return;
        }

        if (t && typeof t.preventDefault === 'function') t.preventDefault();
        this.setAttribute('click-opened', '');
        if (safeToggle(this, true) && this.summaryElement) {
          this.summaryElement.classList.add('is_action-hover');
        }
      };
    });

    // Menü dışı tıklama → hepsini kapat
    document.addEventListener('click', function(e) {
      menuItems.forEach(function(menu) {
        if (!menu.contains(e.target)) {
          menu.removeAttribute('click-opened');
          if (safeToggle(menu, false) && menu.summaryElement) {
            menu.summaryElement.classList.remove('is_action-hover');
          }
        }
      });
    });

    console.log('Dolce Vita Hali menu v2 yuklendi');
  }
})();
